// The desktop app serves this same bundle from app://photentra/, so its origin
// tells us nothing about where the API lives. Electron's preload injects the
// real base URL before any module evaluates; when it's absent we're in a real
// browser and the old rules apply.
const desktopApiBaseUrl =
	typeof window !== "undefined" ? window.__PHOTENTRA_API_BASE_URL__ : undefined;

const isLocalhost =
	typeof window !== "undefined" &&
	(window.location.hostname === "localhost" ||
		window.location.hostname === "127.0.0.1");

// In local development, API runs on port 3001 unless explicitly overridden.
const API_BASE_URL =
	desktopApiBaseUrl ||
	process.env.REACT_APP_API_URL ||
	(isLocalhost ? "http://localhost:3001" : "");
export default API_BASE_URL;
